import React from 'react';
import { LinkSubmitButton } from 'Components/Fields/Buttons';
import { useStore } from 'Hooks/useStore';
import './SignInTVProviderButton.css';

export const SignInTVProviderButton = () => {
  const routes = useStore('appConfig.routes');

  return <LinkSubmitButton className="providerButton" path={routes.mvpd} text="Sign in with TV Provider" />;
};
